import {
    getAxios,
    formDataToRequestParams,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberNotificationSettings(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/notification/settings/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function setMemberNotificationSettings(data = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/notification/settings/set/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberNotificationSetting.js